/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Pencil16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M2.237 10l2.829 2.828-3.398 1.184c-.52.18-.791-.105-.614-.614L2.237 10zM14 12a1 1 0 010 2H9a1 1 0 010-2h5zm-1.49-9.586a2 2 0 010 2.829l-6.473 6.473L3.21 8.887l6.473-6.473a2.001 2.001 0 012.828 0z"
        />
    </AccessibleSVG>
);

export default Pencil16;
